module.exports = __webpack_public_path__ + "media/images/author/author-10-0499fac88bcfbd0252ebf5c6c8ccf366.jpg";